import { IClientTripPriceCalculationFullTicket } from '@bustickus/models-client';
import { Flex } from 'components';
import './style.scss';

interface IProps {
  calculation: IClientTripPriceCalculationFullTicket;
}

function TicketCalculation(props: IProps) {
  const oldPrice = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(
    props.calculation.defaultPrice
  );

  const discountPrice = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(
    props.calculation.discountPrice
  );

  return (
    <Flex
      gap={0}
      direction='column'
      className='ticket-calc-Sq5w'
    >
      <span className='city-tcY2'>
        <b>{props.calculation.tripRouteTitle}</b>
      </span>
      <span>{props.calculation.passengerName}</span>
      <Flex
        justifyContent='flex-end'
        gap={10}
      >
        {props.calculation.defaultPrice > props.calculation.discountPrice && (
          <span className='old-price-ZCcr price-eadV'>{oldPrice}</span>
        )}
        <span className='price-eadV'>
          <b>{discountPrice}</b>
        </span>
      </Flex>
    </Flex>
  );
}

export default TicketCalculation;
